import React from "react";
import LoginPage from "./LoginPage";

const DMLogin = () => {
  return <LoginPage userRole="DM" />;
};

export default DMLogin;
